import React from 'react';
import LibraryManagement2023 from 'views/LibraryManagement2023';

const StudentsTestimonialpage = () => {
  return <LibraryManagement2023 />;
};

export default StudentsTestimonialpage;